module.exports = __webpack_public_path__ + "img/logo-venteny-white.40294379.png";